import React, { Component } from 'react';
import { Row, Col, Button } from 'emerald-ui';
import PropTypes from 'prop-types';

class SignUpFormFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  hasErrors = () => {
    const { currentStep, isFormValid, showErrors } = this.props;
    const section = currentStep === 1 ? 'provider' : 'user';
    if (!isFormValid(section)) {
      showErrors(section);
      return true;
    }
    return false;
  };

  handleSubmit = async () => {
    this.setState({ loading: true });
    await this.props.handleSubmit();
    this.setState({ loading: false });
  };

  handleContinue = () => {
    const { currentStep, onStepChange } = this.props;
    if (this.hasErrors()) {
      return false;
    }
    onStepChange(currentStep + 1);
  };

  render() {
    const { steps = [], currentStep, onStepChange } = this.props;
    return (
      <Row>
        <Col xs={12} className="sign-up-form-footer">
          <Row>
            <Col xs={12} md={6}>
              <h4>The same profile will be used should you apply to another board</h4>
            </Col>
            <Col xs={12} md={6} className="sign-up-form-footer-buttons">
              {steps.length === currentStep && ( //current step is not the last step
                <Button
                  id="signUpFormSubmitButton"
                  color="primary"
                  size="large"
                  disabled={this.state.loading}
                  loading={this.state.loading}
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
              )}
              {steps.length !== currentStep && ( //current step is not the last step
                <Button id="signUpFormContinueButton" color="primary" size="large" onClick={this.handleContinue}>
                  Continue
                </Button>
              )}
              {currentStep !== 1 && (
                <Button id="signUpFormBackButton" size="large" onClick={() => onStepChange(currentStep - 1)}>
                  Back
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

SignUpFormFooter.propTypes = {
  handleSubmit: PropTypes.func,
  isFormValid: PropTypes.func,
  showErrors: PropTypes.func,
  onStepChange: PropTypes.func,
  currentStep: PropTypes.number,
  steps: PropTypes.array,
};

SignUpFormFooter.defaultProps = {
  handleSubmit: () => {},
  isFormValid: () => {},
  showErrors: () => {},
  onStepChange: () => {},
};

export default SignUpFormFooter;



// WEBPACK FOOTER //
// ./src/components/SignUpFormFooter/SignUpFormFooter.js